import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { BrandMark } from './BrandMark';

export function Layout() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <Link to="/difot" className="brand">
          <BrandMark className="brand-mark" />
          <span className="brand-name">
            WARRRL
            <small>Reporting</small>
          </span>
        </Link>
        <nav className="primary-nav">
          <NavLink to="/difot">DIFOT Report</NavLink>
          <NavLink to="/tv">TV Mode</NavLink>
          <NavLink to="/feedback">Customer Feedback</NavLink>
          {profile?.role === 'admin' && <NavLink to="/admin/users">Users</NavLink>}
        </nav>
        <div className="user-menu">
          <span className="user-email">{user?.email}</span>
          <button type="button" className="btn-outline" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
